import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Route, Switch, Redirect } from 'react-router-dom';

import { ConnectedRouter } from 'react-router-redux';
import { TransitionGroup } from 'react-transition-group';
import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import { CardTypes } from '../../utils/enums';
import { height, width } from '../../utils/size';
import { addEventListener, messageEvent } from '../../utils/iframeCommunication.js';

import './Widget.styles.js';

import {
    widgetVisible,
    goToRoute,
    resizeWidget,
    loadLocation,
    widgetEngaged
} from './actions.js';

import { FacebookPixel, initializePixels } from '../../utils/facebookPixel';

import Donation from '../Donation/Donation';
import Poll from '../Poll/Poll';
import SentimentPoll from '../SentimentPoll/SentimentPoll';
import Quiz from '../Quiz/Quiz';
import VoteRegistration from '../VoteRegistration/VoteRegistration';
import ElectionReminder from '../ElectionReminder/ElectionReminder';
import CheckRegistration from '../CheckRegistration/CheckRegistration';
import FindPollingStation from '../FindPollingStation/FindPollingStation';
import Volunteer from '../Volunteer/Volunteer';
import TargetedMultiAction from '../TargetedMultiAction/TargetedMultiAction';
import MultiActionsCard from '../MultiActionsCard/MultiActionsCard';
import PreloadScreen from '../PreloadScreen/PreloadScreen';
import Call from '../Call/Call';
import Email from '../Email/Email';
import Link from '../Link/Link';
import Petition from '../Petition/Petition';
import Tweet from '../Tweet/Tweet';
import Video from '../Video/Video';

const WidgetContainer = styled.div`
    max-width: ${() => width()}px;
    border-top: 2px solid #dbdbdb;
    border-bottom: 2px solid #dbdbdb;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Averta;
    display: flex;
    position: relative;
    overflow: hidden;
    height: ${() => height()}px;
    background-color: white;
`;

//This returns a childFactory to provide to TransitionGroup
const childFactoryCreator = classNames => child =>
    React.cloneElement(child, {
        classNames
    });

const getDefaultRoute = (actionType, cardType, skipFrontCard) => {
    if (cardType === CardTypes.oneAction) {
        if (actionType === 'volunteer') {
            return 'preload/volunteer';
        }
        if (skipFrontCard) {
            return actionType;
        }
        return actionType + '/start';
    } else if (
        cardType === CardTypes.multipleActions ||
        cardType === CardTypes.multiDonation
    ) {
        return 'multiActionsCard';
    } else if (cardType === CardTypes.targetedMultiAction) {
        return 'targetedMultiAction';
    }
};

const isPreviousActionTransition = (
    pathname,
    lastActionIdentifier,
    currentActionIdentifier,
    emailStep2BackButtonClicked
) => {
    let isPreviousActionTransition =
        lastActionIdentifier === currentActionIdentifier &&
        (pathname === '/targetedMultiAction' ||
            pathname === '/multiActionsCard' ||
            emailStep2BackButtonClicked);
    return isPreviousActionTransition;
};

class Widget extends React.Component {
    constructor(props) {
        super(props);
        this.watchForWidgetVisibleEvent(props);
        const widgetReference = this;
        if (typeof window !== 'undefined') {
            window.onresize = function() {
                widgetReference.forceUpdate();
                props.resizeWidget();
            };
            props.resizeWidget();
        }

        initializePixels(props.facebookPixelIds || []);

        props.loadLocation();
    }

    watchForWidgetVisibleEvent(props) {
        function onWidgetVisibleEvent(e) {
            if (
                typeof window !== 'undefined' &&
                (e.data == null ||
                    e.data.isActionButtonWidgetVisible == null ||
                    e.data.isActionButtonWidgetVisible !== true)
            )
                return;
            window.removeEventListener(messageEvent, onWidgetVisibleEvent, false);

            props.widgetVisible(props.widgetRequestId, props.articleUrl);
        }

        addEventListener(messageEvent, onWidgetVisibleEvent, false);
    }

    render() {
        return (
            <WidgetContainer onClick={() => this.props.widgetEngaged(this.props.engaged)}>
                <FacebookPixel />
                <ConnectedRouter history={this.props.history}>
                    <Route
                        render={({ location }) => (
                            <TransitionGroup
                                component={TransitionGroupContainer}
                                childFactory={childFactoryCreator(
                                    isPreviousActionTransition(
                                        this.props.pathname,
                                        this.props.activeAction.identifier,
                                        this.props.lastInitiatedLocalRepIdentifier,
                                        this.props.emailStep2BackButtonClicked
                                    )
                                        ? 'backtransition'
                                        : 'transition'
                                )}
                            >
                                <CssTransition
                                    key={this.props.animationIdentifier}
                                    classNames={
                                        isPreviousActionTransition(
                                            this.props.pathname,
                                            this.props.activeAction.identifier,
                                            this.props.lastInitiatedLocalRepIdentifier,
                                            this.props.emailStep2BackButtonClicked
                                        )
                                            ? 'backtransition'
                                            : 'transition'
                                    }
                                    timeoutInMs={650}
                                >
                                    <TransitionContainerNoExit
                                        isNextActionTransition={
                                            !this.props.isNextActionTransition
                                        }
                                        noAnimation={!this.props.showNextActionAnimation}
                                        zIndex={30}
                                    >
                                        <Switch location={location}>
                                            <Redirect
                                                from="/"
                                                exact
                                                to={this.props.defaultRoute}
                                            />
                                            <Route
                                                path="/donation"
                                                name="Donation"
                                                component={Donation}
                                            />
                                            <Route
                                                path="/poll"
                                                name="Poll"
                                                component={Poll}
                                            />
                                            <Route
                                                path="/sentimentpoll"
                                                name="SentimentPoll"
                                                component={SentimentPoll}
                                            />
                                            <Route
                                                path="/quiz"
                                                name="Quiz"
                                                component={Quiz}
                                            />
                                            <Route
                                                path="/voteRegistration"
                                                name="VoteRegistration"
                                                component={VoteRegistration}
                                            />
                                            <Route
                                                path="/electionReminder"
                                                name="ElectionReminder"
                                                component={ElectionReminder}
                                            />
                                            <Route
                                                path="/findPollingStation"
                                                name="FindPollingStation"
                                                component={FindPollingStation}
                                            />
                                            <Route
                                                path="/checkRegistration"
                                                name="CheckRegistration"
                                                component={CheckRegistration}
                                            />
                                            <Route
                                                path="/call"
                                                name="Call"
                                                component={Call}
                                            />
                                            <Route
                                                path="/email"
                                                name="Email"
                                                component={Email}
                                            />
                                            <Route
                                                path="/link"
                                                name="Link"
                                                component={Link}
                                            />
                                            <Route
                                                path="/video"
                                                name="Video"
                                                component={Video}
                                            />
                                            <Route
                                                path="/tweet"
                                                name="Tweet"
                                                component={Tweet}
                                            />
                                            <Route
                                                path="/petition"
                                                name="Petition"
                                                component={Petition}
                                            />
                                            <Route
                                                path="/preload"
                                                component={PreloadScreen}
                                            />
                                            <Route
                                                path="/targetedMultiAction"
                                                name="TargetedMultiAction"
                                                component={TargetedMultiAction}
                                            />
                                            <Route
                                                path="/multiActionsCard"
                                                name="MultiActionsCard"
                                                component={MultiActionsCard}
                                            />
                                            <Route
                                                path="/volunteer"
                                                name="Volunteer"
                                                component={Volunteer}
                                            />
                                        </Switch>
                                    </TransitionContainerNoExit>
                                </CssTransition>
                            </TransitionGroup>
                        )}
                    />
                </ConnectedRouter>
            </WidgetContainer>
        );
    }
}

Widget.propTypes = {
    history: PropTypes.object.isRequired,
    defaultRoute: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    widgetVisible: PropTypes.func.isRequired,
    goToRoute: PropTypes.func.isRequired,
    showNextActionAnimation: PropTypes.bool,
    animationIdentifier: PropTypes.string,
    isNextActionTransition: PropTypes.bool,
    lastInitiatedLocalRepIdentifier: PropTypes.string,
    pathname: PropTypes.string,
    emailStep2BackButtonClicked: PropTypes.bool,
    resizeWidget: PropTypes.func,
    loadLocation: PropTypes.func,
    facebookPixelIds: PropTypes.array,
    widgetRequestId: PropTypes.string,
    articleUrl: PropTypes.string,
    widgetEngaged: PropTypes.func.isRequired,
    engaged: PropTypes.bool
};

export default connect(
    state => {
        let animationIdentifier =
            state.widget.activeAction.identifier + state.widget.noCardsVisited;

        if (state.router.location != null) {
            const location =
                state.router.location.pathname === '/'
                    ? `/${getDefaultRoute(
                          state.widget.activeAction.type,
                          state.widget.cards[state.widget.activeAction.order - 1].type,
                          state.widget.activeAction.skipFrontCard || false
                      )}`
                    : state.router.location.pathname;
            if (location.indexOf('/start') !== -1) {
                if (location.indexOf('/volunteer') === -1) {
                    animationIdentifier = 'start' + animationIdentifier;
                }
            }
            if (location.indexOf('/targetedMultiAction') !== -1) {
                animationIdentifier = 'targetedMultiAction';
            }
            if (location.indexOf('/multiActionsCard') !== -1) {
                animationIdentifier = 'multiActionsCard';
            }
        }

        return {
            activeAction: state.widget.activeAction,
            showNextActionAnimation: state.widget.showNextActionAnimation,
            isNextActionTransition: state.widget.isNextActionTransition,
            animationIdentifier: animationIdentifier,
            defaultRoute: `/${getDefaultRoute(
                state.widget.activeAction.type,
                state.widget.cards[state.widget.activeAction.order - 1].type,
                state.widget.activeAction.skipFrontCard || false
            )}`,
            pathname:
                state.router.location != null ? state.router.location.pathname : null,
            lastInitiatedLocalRepIdentifier: state.widget.lastInitiatedLocalRepIdentifier,
            emailStep2BackButtonClicked: state.email.backButtonClicked,
            facebookPixelIds: state.widget.facebookPixelIds,
            articleUrl: state.widget.articleUrl,
            widgetRequestId: state.widget.widgetRequestId,
            engaged: state.widget.engaged
        };
    },
    { widgetVisible, goToRoute, resizeWidget, loadLocation, widgetEngaged }
)(Widget);



// WEBPACK FOOTER //
// ./src/containers/Widget/Widget.jsx